import { parseDate } from '../../utils/dateUtil'

const FORMAT_PATTERN = 'yyyy-MM-dd'

export type ChildAgeInfos = {
    childAgeYear: number | null,
    childAgeMonth: number | null,
    childAgeClass: number | null
}

/**
 * 利用日におけるお子様の生年月日情報を計算する
 * @param {string} childBirth yyyy-mm-dd想定のお子さま生年月日
 * @param {string} baseDate yyyy-mm-dd想定の基準日
 * @returns {ChildAgeInfos}
 */
const calcChildAges = (childBirth: string, baseDate: string) => {
    const dChildBirth: Date = parseDate(childBirth, FORMAT_PATTERN)
    const dBaseDate: Date = parseDate(baseDate, FORMAT_PATTERN)

    const age = calculateAgeYearAndMonth(dChildBirth, dBaseDate);

    return {
        childAgeYear: age.years,
        childAgeMonth: age.months,
        childAgeClass: calculateClass(dChildBirth, dBaseDate)
    }
}

// 年齢・月齢を算出
const calculateAgeYearAndMonth = (birthday: Date, baseDate: Date) => {

  // 年齢を計算
  let ageYears = baseDate.getFullYear() - birthday.getFullYear()
  let ageMonths = baseDate.getMonth() - birthday.getMonth()
  const ageDays = baseDate.getDate() - birthday.getDate()
  // 月齢を調整
  if (!isEndOfMonth(baseDate) && ageDays < 0) {
    ageMonths--
  }
  // 月齢が負の場合、1年減らし、月を12ヶ月加算
  if (ageMonths < 0) {
    ageYears--
    ageMonths += 12
  }

  return {
    years: ageYears,
    months: ageMonths
  }
}

// 月末判定（年や月に応じて月末日数が異なることへの考慮）
const isEndOfMonth = (date: Date) => {
  // 日付('date')が属する月末の年月日を取得　
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  // 現在の日付が、月末の日付と一致するかを確認
  return date.getDate() === lastDayOfMonth.getDate()
}

// クラス年齢を算出
const calculateClass = (birthday: Date, baseDate: Date) => {
  let referenceDate

  // 利用日が1月～3月の場合、前年の4月1日を基準にする
  if (baseDate.getMonth() >= 0 && baseDate.getMonth() <= 2) {
    const previousYear = baseDate.getFullYear() - 1
    referenceDate = new Date(`${previousYear}-04-01`)
  } else {
    // 利用日が4月～12月の場合、その年の4月1日を基準にする
    referenceDate = new Date(`${baseDate.getFullYear()}-04-01`)
  }

  // 年齢を計算
  let classAge = referenceDate.getFullYear() - birthday.getFullYear()
  if (referenceDate.getMonth() < birthday.getMonth() ||
    (referenceDate.getMonth() === birthday.getMonth() && referenceDate.getDate() < birthday.getDate())) {
    classAge--
  }
  if (Math.sign(classAge) === -1) classAge = 0

  return classAge
}

export default calcChildAges